import { Injectable } from '@angular/core';
import { createTRPCProxyClient } from '@trpc/client';
import { environment } from '../../../environments/environment';
import { constants } from '../../constants';
import { getTRPCClientOptions } from '../../utils/trpc.utils';
import { LocalDataKey, LocalStorageService } from '../local-storage/local-storage.service';
import { SessionsService } from '../sessions/sessions.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorReportingService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private client: any;

  constructor(
    private localStorageService: LocalStorageService,
    private sessionsService: SessionsService,
  ) {
    this.client = createTRPCProxyClient(getTRPCClientOptions(`${environment.apiUrl}/errorReporting`,() => this.sessionsService.getAccessToken()));
  }

  log(location: string, step: string, error: unknown): void {
    if (['prod', 'stg'].includes(environment.name)) {
      const errorName = (error as Error).name ?? 'Unknown name';
      const errorMessage = (error as Error).message ?? 'Unknown message';
      let errorStackTrace = (error as Error).stack ?? JSON.stringify(error);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if ((error as any).error?.error?.data) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        errorStackTrace = JSON.stringify((error as any).error.error.data);
      }
      let anonymousUserId = this.localStorageService.getItem<string>(LocalDataKey.AnonymousUserId);
      if (!anonymousUserId) {
        anonymousUserId = crypto && crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).substring(2, 15);
        this.localStorageService.set(LocalDataKey.AnonymousUserId, anonymousUserId);
      }
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.client.create.mutate({
        context: {
          anonymousUserId,
          url: window.location.href,
          userAgent: navigator.userAgent,
          functionName: location,
        },
        message: `Error in ${location} at ${step}: ${errorName} - ${errorMessage} / ${errorStackTrace ?? 'Unknown stack trace'}`,
        serviceContext: {
          service: 'homein-hogar-app',
          version: `0.0.1-${constants.appVersionCode}`,
        },
      });
    } else {
      console.error(`Error in ${location} at ${step}`, error);
    }
  }
}
